// Normaliza status (pt → en) para filtro unificado.
// Extraído de lojas.jsx (Fase 4 router hardening) para que consumidores fora
// da página de Lojas (drawers, cockpit) não precisem importar o módulo
// inteiro de LojasPage só para esta função pura — isso quebrava o code
// splitting ao puxar LojasPage para o bundle eager sempre que só o
// normalizador de status era necessário.
export const normStatus = (s) => {
  const map = {
    ativo: 'active',
    inadimplente: 'overdue',
    past_due: 'overdue',
    suspenso: 'suspended',
    cancelado: 'cancelled',
    provisionando: 'provisioning',
  };
  return map[s] || s;
};
